import React from "react";
import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { HubIcon } from "../../components";
import { StyledBarTooltip } from "./styles";
import { currency, decimal } from "./helper";

const GoalRow = ({ label, value, goal, color, format }) => {
  const pct = goal ? Math.min((value / goal) * 100, 100) : 0;
  return (
    <Stack gap="4px">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          variant="caption"
          sx={{ color: "text.secondary", fontSize: 10 }}
        >
          {label}
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 600, fontSize: 11 }}>
          {format(value)}
          <Typography
            component="span"
            variant="caption"
            sx={{ color: "text.disabled", fontSize: 10, ml: "3px" }}
          >
            / {format(goal)}
          </Typography>
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={pct}
        sx={{
          height: 4,
          borderRadius: 2,
          backgroundColor: "rgba(0,0,0,0.06)",
          "& .MuiLinearProgress-bar": {
            borderRadius: 2,
            backgroundColor: color,
          },
        }}
      />
    </Stack>
  );
};

const SchedulerBarTooltip = ({
  workOrder,
  customer,
  partName,
  startDate,
  hours = 0,
  revenue = 0,
  weeklyHourGoal = 0,
  weeklyRevenueGoal = 0,
}) => {
  const formattedDate = startDate
    ? dayjs(startDate).format("MMM D, YYYY")
    : "—";

  return (
    <StyledBarTooltip>
      <Stack
        gap="2px"
        pb="8px"
        borderBottom="1px solid"
        borderColor="hubColors.greyLight"
      >
        <Stack direction="row" gap="6px" alignItems="center">
          <HubIcon icon="FileText" size={11} />
          <Typography variant="boldCaptionL" fontSize="12px">
            {workOrder}
          </Typography>
        </Stack>
        {customer && (
          <Stack direction="row" gap="6px" alignItems="center">
            <HubIcon icon="User" size={10} />
            <Typography variant="caption" fontSize="10px">
              {customer}
            </Typography>
          </Stack>
        )}
      </Stack>

      <Stack gap="6px" pt="8px" pb="8px">
        {partName && (
          <Stack direction="row" gap="6px" alignItems="center">
            <HubIcon icon="Settings" size={10} />
            <Typography variant="caption" sx={{ fontSize: 10 }}>
              {partName}
            </Typography>
          </Stack>
        )}
        <Stack direction="row" gap="6px" alignItems="center">
          <HubIcon icon="Calendar" size={10} />
          <Typography variant="caption" sx={{ fontSize: 10 }}>
            {formattedDate}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        gap="8px"
        pt="6px"
        borderTop="1px solid"
        borderColor="hubColors.greyLight"
      >
        <GoalRow
          label="Hours"
          value={decimal(hours)}
          goal={decimal(weeklyHourGoal)}
          color="#DF9E44"
          format={(v) => `${v} hrs`}
        />
        <GoalRow
          label="Revenue"
          value={revenue}
          goal={weeklyRevenueGoal}
          color="#CD683E"
          format={currency}
        />
      </Stack>
    </StyledBarTooltip>
  );
};

export default SchedulerBarTooltip;
